<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:pageArray="screen.pageArray"
		paging
		index
		v-bind="pagingInfo"
		:columns="columns"
		:rows="rows"
		fit="fit"
		:stripe="false"
		selection
		:excel="(isButton_(scrId, 'EX') && (flgPqyrgGrp || flgPqyrvGrp || flgPqyapGrp)) || flgOsGrp"
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<sf-button line size="sm" v-if="(isButton_(scrId, 'CS') && (flgPqyrgGrp || flgPqyrvGrp || flgPqyapGrp)) || flgOsGrp" icon="trash" color="error" :onClick="deleteAction">{{
				getMessage_('QWCC001136')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCkuMng/store/helpers';
import PartCku from '@pqy/pcku/PartCku/PartCku';
export default {
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false },
		flgPqyapGrp: { type: Boolean, default: false },
		flgPqyrvGrp: { type: Boolean, default: false },
		flgPqyrgGrp: { type: Boolean, default: false }
	},
	data() {
		return {
			screen: {}
		};
	},
	async created() {
		this.screen = this.screenArray.get(this.scrId);
		await this.getCommCodes_({ key: 'partClList', codeType: 'PART_CL' }); //유형;
		await this.getCommCodes_({ key: 'ovrlJgmtList', codeType: 'OVRL_JGMT' }); //종합판정;
		await this.getCommCodes_({ key: 'pgsStPcList', codeType: 'PGS_ST_PC' }); //부품검사 진행상태;
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.resultList;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					minWidth: '100px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'partNm',
					minWidth: '100px',
					sortable: true,
					highlight: true,
					clickEvent: this.clickPartNo
				},
				{
					label: this.getMessage_('QWCC000069'), //유형
					prop: 'partClCd',
					minWidth: '80px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getPartClList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC000958'), //협력사
					prop: 'cofCd',
					minWidth: '1px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000958'), //협력사명
					prop: 'cofNm',
					minWidth: '99px',
					sortable: true
				},
				// {
				// 	label: this.getMessage_('QWCC000006'), //변경번호
				// 	prop: 'altrNo',
				// 	minWidth: '110px',
				// 	sortable: true
				// },
				{
					label: this.getMessage_('QWCC000005'), //검사번호
					prop: 'ckuNo',
					minWidth: '130px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000009'), //검사원Id
					prop: 'ckurId',
					minWidth: '1px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000009'), //검사원명
					prop: 'ckurNm',
					minWidth: '80px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000070'), //검사일자
					prop: 'ckuDd',
					minWidth: '80px',
					sortable: true
				},
				// {
				// 	label: this.getMessage_('QWCC001217'), //검사시작시간
				// 	prop: 'ckuStrtDt',
				// 	minWidth: '130px',
				// 	sortable: true
				// },
				{
					label: this.getMessage_('QWCC001470'), //LOT번호(FR)
					prop: 'lotFromNo',
					minWidth: '130px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001469'), //LOT번호(TO)
					prop: 'lotToNo',
					minWidth: '130px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC002081'), //LOT번호(TO)
					prop: 'orderNo',
					minWidth: '130px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000073'), //검사수량
					prop: 'ckuQty',
					minWidth: '80px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC000074'), //불량수량
					prop: 'badQty',
					minWidth: '80px',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001219'), //검사상태
					prop: 'pgsStCd',
					minWidth: '80px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getPgsStPcList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001270'), //불량처리
					prop: 'pprPgsStNm',
					minWidth: '100px',
					sortable: true,
					highlight: true,
					clickEvent: this.clickPprPgsStNm
				},
				{
					label: this.getMessage_('QWCC001271'), //부품상태(종합판정)
					prop: 'ovrlJgmtCd',
					minWidth: '100px',
					sortable: true,
					form: {
						type: 'select',
						options: this.getOvrlJgmtList_,
						isDisabled: ({}) => true // 에디트 방지
					}
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		// getCheckboxProps(row) {
        //    console.log(row.pprPgsStNm, 'pprPgsStNm');
        //    return ({
        //         props: {
        //         	disabled: row.pprPgsStNm === null,
		// 		}
		// 	})
    	// },
		isClickable(row){
			//console.log(row);
			if (row.pprPgsStNm) {
				return true;
			}else{
				return false;
			}
		},
		deleteAction() {
			//체크박스로 선택된 행이 있는지 확인
			const selected = this.$refs.dataTable.getSelectedRows();
			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			// 유효성 검사
			try {
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001196'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001136'), clickFn: this.deletePartCkuMngList }] //저장
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async deletePartCkuMngList() {
			this.$sf_toggleLoading(true);
			try {
				const delRows = this.$refs.dataTable.getSelectedRows();

				// 저장 전 Grid 유효성 체크
				this.makeValidateGrid(delRows);
				
				// console.log(delRows);
				// const partNo = this.searchParams.partNo;
				// const params = {  reqBody: delRows };
				const { code, messageCd } = await this.deletePartCkuMngList_(delRows);
				//console.log(code, messageCd);
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				// this.resetTable();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		makeValidateGrid(resultList) {
			
			let passYn = 'Y';
			let errColumn = '';
			let fullYn = '';
			//console.log(resultList);
			
			for (let i = 0; i < resultList.length; i++) {
				let ckuNo = resultList[i].ckuNo;
				let pprPgsStNm = resultList[i].pprPgsStNm;
				if(pprPgsStNm && pprPgsStNm !== '미발행'){
					passYn = 'N';
					errColumn = ckuNo;
					break;
				}
				
			}
			

			if (passYn === 'N') {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC002083'), [errColumn])); //{0} 열을 모두 입력해주시기 바랍니다.
			}
		},
		async clickPartNo(row) {
			const { partNo, ckuNo } = row;
			const name = this.getMessage_('QWCC000938');
			let item = {
				name,
				component: PartCku,
				scrId: this.partCkuScrId, //이동할 scrId
				msgKey: 'QWCC000938'
			};

			await this.getScreen_({ scrId: item.scrId });
			await this.$sf_removeTab(item.scrId);
			await this.$sf_addTab(item, item.scrId, { scrId: item.scrId, partNo, ckuNo });
		},
		async clickPprPgsStNm(row) {
			this.$emit('OpenPopup', row, 'partMng');
		}
	}
};
</script>

<style></style>
